import {
  FinalInvoiceGetRequestDto,
  FinalInvoiceGetResponseDto,
  InvoicePdfGetRequestDto,
  InvoicePdfGetResponseDto,
} from '~/store/apis/dtos/invoices/invoices.dto';
import { myPagesBaseApi } from '../../_baseApi/myPages.base.api';
import { generateParams } from '~/store/apis/utils/generateParams';
import { generatePdfHelper } from '~/helpers/generatePdf.helper';

export const invoicesApi = myPagesBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getInvoicePdf: builder.query<
      InvoicePdfGetResponseDto[] | undefined,
      InvoicePdfGetRequestDto
    >({
      async queryFn({ ...rest }, _queryApi, _extraOptions, fetchWithBQ) {
        const response = await fetchWithBQ({
          url: `/files/pdf/invoice?${generateParams(rest)}`,
        });
        if (response.error) return { error: response.error };
        const data = response.data as InvoicePdfGetResponseDto[];
        data?.forEach((element) => {
          generatePdfHelper(
            element.content,
            'invoice',
            rest.activeCompanyName,
            element.format
          );
        });
        return { data };
      },
      providesTags: (_, _meta, arg) => [
        { type: 'InvoicePdf', id: arg.clientId },
      ],
    }),

    getFinalInvoice: builder.query<
      FinalInvoiceGetResponseDto | undefined,
      FinalInvoiceGetRequestDto
    >({
      query: ({ ...rest }) => ({
        url: `/invoices/final?${generateParams(rest)}`,
        providesTags: ['FinalInvoice'],
      }),
    }),
    getPdfFiles: builder.query<any, InvoicePdfGetRequestDto>({
      async queryFn({ ...rest }, _queryApi, _extraOptions, fetchWithBQ) {
        const response = await fetchWithBQ({
          url: `/files/pdf?${generateParams(rest)}`,
          responseHandler: async (res) => {
            if (!res.ok) {
              throw new Error(
                'Error occurred while fetching non-JSON response'
              );
            }
            return await res.text();
          },
        });
        if (response.error) return { error: response.error };
        const data = response.data as string;
        generatePdfHelper(
          data,
          rest?.documentType ?? '',
          rest.activeCompanyName
        );

        return { data };
      },
      providesTags: (_, _meta, arg) => [
        { type: 'DownloadFinalInvoice', id: arg.clientId },
      ],
    }),
  }),
});
export const {
  useLazyGetInvoicePdfQuery,
  useLazyGetFinalInvoiceQuery,
  useLazyGetPdfFilesQuery,
} = invoicesApi;
